import { SilobagNewEditForm } from '@old/features/silobags/silobag-forms/silobag-new-edit-form';

export function SilobagCreatePage() {
  return <SilobagNewEditForm type="new" />;
}
